import React, { useEffect, useRef, useState, useMemo } from 'react';
import { get, post, put, patch } from '../services/apiController';
import { TABLE_DEFAULT_LIMIT, DEBOUNCE_DELAY } from '../util/constant';
import { Button, Col, FloatingLabel, Form, Modal, Row, Table, Spinner } from 'react-bootstrap';
import { toast, ToastContainer } from 'react-toastify';
import { ViewIcon, DownloadIcon, UploadIcon, EditIcon } from './icons';
import 'react-toastify/dist/ReactToastify.css';
import PaginationInPage from './Pagination';
import { MdDelete } from 'react-icons/md';
import { get_auth_key, getStoredData } from '../util';
import { states } from '../util/constant';
import { GrDocumentPdf, GrDocumentExcel } from 'react-icons/gr';
import useDebounce from './useDebounce';
import Breadcrumb from '../components/Breadcrumb';
import Company from '../components/company';
import Vendor from '../components/vendor';
import { GetSingleVendor } from '../components/vendor/singleVendor';
import { FaQrcode } from 'react-icons/fa';
import { QrCodeDownload } from '../util/helper';
import QRCode from 'react-qr-code';

const GRN = () => {
  const formFields = {
    bill_number: '',
    date_of_purchase: '',
    date_of_put_to_use: '',
    charge_type: '',
    charge_amount: '',
    grn_number: '',
    grn_date: '',
    total: '',
    vendorMasterId: '',
    assetsInfo: [],
  };

  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [grnForm, setGrnForm] = useState(formFields);
  const [showConfirmModel, setShowConfirmModel] = useState(false);
  const [grnList, setGrnList] = useState([]);
  const [locationList, setLocationList] = useState([]);
  const [assetCategoryList, setAssetCategoryList] = useState([]);
  const [inputFields, setInputFields] = useState([]);
  const [view, setView] = useState(false);
  const [edit, setEdit] = useState(false);
  const intialTotals = { _totalCGST: 0, _totalIGST: 0, _totalSGST: 0, _totalWithoutGST: 0 };
  const [totals, setTotals] = useState(intialTotals);
  const [subTotal, setSubTotal] = useState(0);
  const [grnBtnDisable, setGrnBtnDisable] = useState(false);

  const clickAssetBtn = useRef(null);
  const clickSubmitBtn = useRef(null);
  const clickToDownload = useRef(null);
  const storedData = JSON.parse(getStoredData(get_auth_key()));
  const [uploadModel, setUploadModel] = useState(false);
  const [idToUpdated, setIdToUpdated] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [locationType, setLocationType] = useState('');

  const admins = ['admin', 'super-admin', 'fixed-asset-admin'].includes(storedData.role);

  const [state, setState] = useState({
    query: '',
    locationId: !admins ? storedData?.locationId[0] || '' : '',
    assetCategoryQuery: '',
    dateFrom: '',
    dateTo: '',
    companyId: !admins ? storedData?.companyId || '' : '',
  });

  function calculateGRNNumber() {
    get('/grns/getgrn?grn_date=' + grnForm.grn_date).then((response) => {
      setGrnForm({ ...grnForm, grn_number: response.data });
    });
  }

  function calculateAssetNumber(assetCategoryId, index) {
    if (assetCategoryId !== '') {
      const category = assetCategoryList.find((cat) => {
        return cat.id === parseInt(assetCategoryId);
      });
      let assetChar = category?.name.toUpperCase().slice(0, 3);
      
      // Don't load location data here, just use the existing asset number format
      // or use a default if it doesn't exist yet
      let existingAssetNumber = '';
      if (inputFields[index] && inputFields[index].asset_number) {
        existingAssetNumber = inputFields[index].asset_number;
      }
      
      // Extract location number from existing asset number or use default
      let locationPart = '-';
      if (existingAssetNumber && existingAssetNumber.startsWith('CG/')) {
        const parts = existingAssetNumber.split('/');
        if (parts.length > 1) {
          locationPart = parts[1];
        }
      }
      
      return [
        `CG/${locationPart}/${assetChar}/` +
        grnForm?.grn_number?.slice(4, 7) +
        (index + 1).toString().padStart(2, '0') +
        '/' +
        grnForm.grn_number.slice(8, 18),
        category?.type,
      ];
    } else {
      // For new entries without category, maintain the location part if it exists
      let locationPart = '-';
      if (inputFields[index] && inputFields[index].asset_number) {
        const parts = inputFields[index].asset_number.split('/');
        if (parts.length > 1) {
          locationPart = parts[1];
        }
      }
      
      return [`CG/${locationPart}/XXX/` + grnForm.grn_number.replace('GRN/', '') + (index + 1).toString().padStart(2, '0'), ''];
    }
  }

  const onGrnDateChangeCalculateAssetNo = () => {
    for (let index = 0; index < grnForm.assetsInfo.length; index++) {
      if (grnForm.assetsInfo[index].assetCategoryId !== '') {
        // Get asset category character
        const category = assetCategoryList.find((cat) => {
          return cat.id === parseInt(grnForm.assetsInfo[index].assetCategoryId);
        });
        let assetChar = category?.name.toUpperCase().slice(0, 3) || 'XXX';
        
        // Extract location number from existing asset number or use default
        let locationPart = '-';
        const existingAssetNumber = grnForm.assetsInfo[index].asset_number;
        if (existingAssetNumber && existingAssetNumber.startsWith('CG/')) {
          const parts = existingAssetNumber.split('/');
          if (parts.length > 1) {
            locationPart = parts[1];
          }
        }
        
        grnForm.assetsInfo[index].asset_number =
          `CG/${locationPart}/${assetChar}/` +
          grnForm?.grn_number?.slice(4, 7) +
          (index + 1).toString().padStart(2, '0') +
          '/' +
          grnForm.grn_number.slice(8, 18);
      } else {
        // For entries without category, maintain the location part if it exists
        let locationPart = '-';
        const existingAssetNumber = grnForm.assetsInfo[index].asset_number;
        if (existingAssetNumber && existingAssetNumber.startsWith('CG/')) {
          const parts = existingAssetNumber.split('/');
          if (parts.length > 1) {
            locationPart = parts[1];
          }
        }
        
        grnForm.assetsInfo[index].asset_number =
          `CG/${locationPart}/XXX/` + grnForm?.grn_number?.slice(4, 7) + (index + 1).toString().padStart(2, '0') + '/' + grnForm.grn_number.slice(8, 18);
      }
    }
  };

  useMemo(() => {
    onGrnDateChangeCalculateAssetNo();
  }, [grnForm.grn_number]);

  const handleShow = () => {
    setGrnBtnDisable(false);
    setShowConfirmModel(true);
    setTimeout(() => {
      clickAssetBtn.current?.click();
    }, 100);
  };

  const handleClose = () => {
    setGrnBtnDisable(false);
    setShowConfirmModel(false);
    setInputFields([]);
    setGrnForm(formFields);
    setView(false);
    setEdit(false);
    setIsLoading(false);
    setTotals(intialTotals);
    setSubTotal(0);
  };

  const uploadInvoice = (e, id) => {
    e.preventDefault();
    setIdToUpdated(id);
    setUploadModel(true);
  };

  let formData = new FormData();
  const handleFileChange = (e) => {
    e.preventDefault();
    formData.append('invoice', e.target.files[0]);
  };

  const handleViewAndEdit = (e, id, view, conditionType) => {
    e.preventDefault();
    try {
      setIsLoading(true);
      conditionType !== 'download' ? setShowConfirmModel(true) : setShowConfirmModel(false);
      get(`/grns/${id}/?conditionType=${conditionType}`).then(async (res) => {
        if (conditionType !== 'download') {
          const Data = res.data;
          const vendorData = await GetSingleVendor(Data?.vendorMasterId);
          setGrnForm({
            ...Data,
            vendorMasterId: vendorData.id,
            gst_num: vendorData?.gst_num || '',
            address: vendorData?.address || '',
            contact_num: vendorData?.contact_num || '',
            email: vendorData?.email || '',
            city: vendorData?.city || '',
            pincode: vendorData?.pincode || '',
            state: vendorData?.state || '',
            country: vendorData?.country || '',
          });
          let _inputFields = Data.assetsInfo;
          let _totalWithoutGST = 0;
          let _totalCGST = 0;
          let _totalSGST = 0;
          let _totalIGST = 0;
          for (let x = 0; x < _inputFields.length; x++) {
            let locationData = loadLocationData(_inputFields[x].locationId);
            _inputFields[x]['companyId'] = locationData?.companyId;
            _inputFields[x]['locationType'] = locationData?.type;
            
            // Make sure the asset number has the location number
            if (_inputFields[x].locationId && locationData) {
              const locationNumber = locationData?.number || '-';
              const assetNumber = _inputFields[x].asset_number;
              
              // Get asset category character
              let assetChar = 'XXX';
              if (_inputFields[x].assetCategoryId) {
                const category = assetCategoryList.find((cat) => {
                  return cat.id === parseInt(_inputFields[x].assetCategoryId);
                });
                if (category) {
                  assetChar = category.name.toUpperCase().slice(0, 3);
                }
              }
              
              // Update asset number only if needed
              if (assetNumber && assetNumber.includes('/')) {
                const parts = assetNumber.split('/');
                if (parts.length >= 5) {
                  // Format with location and category already included
                  _inputFields[x].asset_number = `CG/${locationNumber}/${assetChar}/${parts[3]}/${parts[4]}`;
                } else if (parts.length >= 4) {
                  // Format with location already included
                  _inputFields[x].asset_number = `CG/${locationNumber}/${assetChar}/${parts[3]}`;
                } else if (parts.length >= 3) {
                  // Old format without location
                  _inputFields[x].asset_number = `CG/${locationNumber}/${assetChar}/${parts[2]}`;
                } else if (parts.length >= 2) {
                  // Handle case where the format might be different
                  _inputFields[x].asset_number = `CG/${locationNumber}/${assetChar}/${parts[parts.length-1]}`;
                }
              }
            }
            
            if (_inputFields[x].quantity !== -1) {
              let totalWithoutGST = _inputFields[x].quantity * _inputFields[x].cost_per_unit;
              let totalSGST = (totalWithoutGST * _inputFields[x].sgst) / 100;
              let totalCGST = (totalWithoutGST * _inputFields[x].cgst) / 100;
              let totalIGST = (totalWithoutGST * _inputFields[x].igst) / 100;

              _inputFields[x]['totalWithoutGST'] = totalWithoutGST;
              _inputFields[x]['totalCGST'] = totalCGST;
              _inputFields[x]['totalSGST'] = totalSGST;
              _inputFields[x]['totalIGST'] = totalIGST;

              _totalWithoutGST += parseFloat(totalWithoutGST || 0);
              _totalCGST += parseFloat(totalCGST || 0);
              _totalSGST += parseFloat(totalSGST || 0);
              _totalIGST += parseFloat(totalIGST || 0);
            }
          }
          setInputFields(_inputFields);
          if (conditionType === 'editMode') {
            setEdit(true);
          }
          setView(view);
          setTotals({ ...totals, _totalWithoutGST, _totalCGST, _totalIGST, _totalSGST });
          setSubTotal(Data.total);
          setIsLoading(false);
        } else {
          clickToDownload.current.href = `${process.env.REACT_APP_BASE_URL}/file/download?filePath=${res.data}`;
          setTimeout(() => {
            clickToDownload.current.click();
          }, 500);
          setIsLoading(false);
        }
      });
    } catch (error) {
      setIsLoading(false);
      toast.error(error?.response?.data?.data?.rows?.message || 'Something went wrong');
    }
  };

  const handleUpload = async (e, id) => {
    e.preventDefault();
    try {
      patch(formData, '/grns/' + id, false)
        .then((res) => {
          toast.success(res?.data?.message);
          setUploadModel(false);
          setIdToUpdated('');
          getGRNs();
        })
        .catch((err) => {
          toast.error(err?.response?.data?.data?.message);
        });
    } catch (err) {
      toast.error(err?.message || 'Something Went Wrong');
    }
  };

  const handleChange = (event) => {
    event.preventDefault();
    let name = event.target.name;
    let value = event.target.value;
    let _grnForm = { ...grnForm, [name]: value };
    if (name === 'date_of_purchase') {
      _grnForm = { ..._grnForm, date_of_put_to_use: event.target.value };
    } else if (name === 'bill_number') {
      _grnForm = {
        ..._grnForm,
        bill_number: value.toUpperCase(),
      };
    } else if (name === 'charge_type' || name === 'charge_amount') {
      const updatedChargeAmount = parseFloat(value) || 0;
      const totalChargeAmount = _grnForm.assetsInfo.reduce((acc, asset) => {
        return acc + parseFloat(asset.total || 0);
      }, updatedChargeAmount);
      setSubTotal(totalChargeAmount);
      if (name === 'charge_type') {
        _grnForm = { ..._grnForm, charge_amount: '' };
      }
    }
    setGrnForm(_grnForm);
  };

  const handleVendorChange = async (vendorId) => {
    try {
      const vendorData = await GetSingleVendor(vendorId);
      setGrnForm({
        ...grnForm,
        vendorMasterId: vendorId,
        gst_num: vendorData?.gst_num || '',
        address: vendorData?.address || '',
        contact_num: vendorData?.contact_num || '',
        email: vendorData?.email || '',
        city: vendorData?.city || '',
        pincode: vendorData?.pincode || '',
        state: vendorData?.state || '',
        country: vendorData?.country || '',
      });
    } catch (error) {
      console.error('Error handling vendor change:', error);
    }
  };

  useEffect(() => {
    if (grnForm.grn_date !== '' && view === false) {
      calculateGRNNumber();
    }
  }, [grnForm.grn_date]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if ('id' in grnForm) {
      try {
        await put(grnForm, '/grns/update/' + grnForm.id);
        toast.success('GRN updated successfully');
        setShowConfirmModel(false);
        setInputFields([]);
        setGrnForm(formFields);
        setView(false);
        setEdit(false);
        setTotals(intialTotals);
        setSubTotal(0);
        getGRNs();
      } catch (err) {
        toast.error(err?.response?.data?.data?.message || err.message, {
          autoClose: 4000,
        });
      }
    } else {
      try {
        await post(grnForm, '/grns/');
        toast.success('GRN created successfully');
        setGrnBtnDisable(true);
        setShowConfirmModel(false);
        setInputFields([]);
        setGrnForm(formFields);
        setView(false);
        setEdit(false);
        setTotals(intialTotals);
        setSubTotal(0);
        getGRNs();
      } catch (err) {
        setGrnBtnDisable(false);
        toast.error(err?.response?.data?.data?.message || err.message, {
          autoClose: 4000,
        });
        if (err?.response?.data?.data?.message.startsWith('We already') === true) {
          calculateGRNNumber();
          calculateAssetNumber(grnForm?.assetCategoryId);
          clickSubmitBtn.current.click();
        }
      }
    }
  };

  function getGRNs(conditionType) {
    try {
      if (conditionType === 'download') {
        get(
          `/grns/?&locationId=${state.locationId}&assetCategoryId=${state.assetCategoryQuery}&query=${state.query}&dateFrom=${state.dateFrom}&dateTo=${state.dateTo}&conditionType=${conditionType}&companyId=${state.companyId}`
        ).then((response) => {
          clickToDownload.current.href = `${process.env.REACT_APP_BASE_URL}/file/download?filePath=${response.data.filePath}`;
          setTimeout(() => {
            clickToDownload.current.click();
          }, 500);
        });
      } else {
        get(
          `/grns/?page=${currentPage}&limit=${TABLE_DEFAULT_LIMIT}&locationId=${state.locationId}&assetCategoryId=${state.assetCategoryQuery}&query=${state.query}&dateFrom=${state.dateFrom}&dateTo=${state.dateTo}&companyId=${state.companyId}`
        ).then((response) => {
          setGrnList(response.data.rows);
          setTotalRecords(response.data.count);
        });
      }
    } catch (err) {
      toast.error(err.response.data.data.message);
    }
  }

  function getLocations() {
    try {
      get(`/branches`).then((response) => {
        setLocationList(response.data.rows);
        if (!admins) {
          const data = response?.data?.rows?.find((item) => {
            return item.id === storedData?.locationId[0];
          });
          setLocationType(data?.type);
        }
      });
    } catch (err) {
      toast.error(err.response.data.data.message);
    }
  }

  function getAssetCategories() {
    try {
      get(`/asset-categories`).then((response) => {
        setAssetCategoryList(response.data.rows);
      });
    } catch (err) {
      toast.error(err.response.data.data.message);
    }
  }

  useEffect(() => {
    getGRNs();
  }, [currentPage]);

  useDebounce(
    () => {
      if (currentPage !== 1) {
        setCurrentPage(1);
      } else {
        getGRNs();
      }
    },
    [state],
    DEBOUNCE_DELAY
  );

  useEffect(() => {
    getLocations();
    getAssetCategories();
  }, []);

  const downloadQrCode = (e, item) => {
    e.preventDefault()
    QrCodeDownload(`temp-qr-${item.id}`, item.grn_number, item?.VendorMaster?.name);
  };


  const handleAddInput = async () => {
    const newAssetInfo = [...inputFields];
    newAssetInfo.push({
      assetCategoryId: '',
      asset_name: '',
      asset_number: `CG/-/XXX/` + (grnForm.grn_number ? grnForm.grn_number.replace('GRN/', '') + (newAssetInfo.length + 1).toString().padStart(2, '0') : ''),
      asset_type: '',
      totalgst: '',
      gst_type: '',
      cgst: '',
      sgst: '',
      igst: '',
      cost_per_unit: '',
      locationId: '',
      locationType: '',
      companyId: '',
      quantity: '',
      gst_option: 'withGST',
      capitalisation: 'withGST',
      capitalisedValue: 0,
      unit: '',
      vehicleNumber: '',
      chasisNumber: '',
      engineNumber: '',
    });
    setInputFields(newAssetInfo);
    setGrnForm({ ...grnForm, assetsInfo: newAssetInfo });
  };

  const handleRemoveInput = (index) => {
    const newAssetInfo = [...inputFields];
    setTotals({
      _totalWithoutGST: parseInt(totals._totalWithoutGST) - parseInt(newAssetInfo[index]['totalWithoutGST'] || 0),
      _totalCGST: parseInt(totals._totalCGST) - parseInt(newAssetInfo[index]['totalCGST'] || 0),
      _totalIGST: parseInt(totals._totalIGST) - parseInt(newAssetInfo[index]['totalIGST'] || 0),
      _totalSGST: parseInt(totals._totalSGST) - parseInt(newAssetInfo[index]['totalSGST'] || 0),
    });
    setSubTotal(parseInt(subTotal) - parseInt(newAssetInfo[index]['total'] || 0));
    newAssetInfo.splice(index, 1);
    setInputFields(newAssetInfo);
    setGrnForm({ ...grnForm, assetsInfo: newAssetInfo });
  };

  const calculateTotal = (Qty, cost_per_unit, totalgst) => {
    const total = (Qty || 0) * (cost_per_unit || 0) + ((Qty || 0) * (cost_per_unit || 0) * totalgst) / 100;
    return total.toFixed(2);
  };

  const loadLocationData = (locationId) => {
    return locationList.find((item) => {
      return item?.id === parseInt(locationId);
    });
  };

  const handleInputChange = (index, event, fieldName) => {
    let newAssetInfo = [...inputFields];
    if (fieldName === 'gst_type' && event.target.value === 'interstate') {
      newAssetInfo[index]['sgst'] = 0;
      newAssetInfo[index]['cgst'] = 0;
      newAssetInfo[index]['totalgst'] = 0;
      let totalgst = newAssetInfo[index]['totalgst'];
      let cost_per_unit = newAssetInfo[index]['cost_per_unit'];
      let quantity = newAssetInfo[index]['quantity'];
      newAssetInfo[index]['totalCGST'] = (quantity * cost_per_unit * newAssetInfo[index]['cgst']) / 100;
      newAssetInfo[index]['totalSGST'] = (quantity * cost_per_unit * newAssetInfo[index]['sgst']) / 100;

      newAssetInfo[index]['totalWithoutGST'] = quantity * cost_per_unit;
      newAssetInfo[index]['total'] = calculateTotal(quantity, cost_per_unit, totalgst);

      // set capitalised value
      if (newAssetInfo[index]['capitalisation'] === 'withoutGST') {
        newAssetInfo[index]['capitalisedValue'] = quantity * cost_per_unit;
      } else {
        newAssetInfo[index]['capitalisation'] = 'withGST';
        newAssetInfo[index]['capitalisedValue'] = calculateTotal(quantity, cost_per_unit, totalgst);
      }
    }
    if (fieldName === 'gst_type' && event.target.value === 'local') {
      newAssetInfo[index]['igst'] = 0;
      newAssetInfo[index]['totalgst'] = 0;
      let totalgst = newAssetInfo[index]['totalgst'];
      let cost_per_unit = newAssetInfo[index]['cost_per_unit'];
      let quantity = newAssetInfo[index]['quantity'];
      newAssetInfo[index]['totalWithoutGST'] = quantity * cost_per_unit;
      newAssetInfo[index]['totalIGST'] = quantity * cost_per_unit * newAssetInfo[index]['igst'];
      newAssetInfo[index]['total'] = calculateTotal(quantity, cost_per_unit, totalgst);
      // set capitalised value
      if (newAssetInfo[index]['capitalisation'] === 'withoutGST') {
        newAssetInfo[index]['capitalisedValue'] = quantity * cost_per_unit;
      } else {
        newAssetInfo[index]['capitalisation'] = 'withGST';
        newAssetInfo[index]['capitalisedValue'] = calculateTotal(quantity, cost_per_unit, totalgst);
      }
    }
    if (fieldName === 'gst_type' && event.target.value === '') {
      newAssetInfo[index]['igst'] = 0;
      newAssetInfo[index]['sgst'] = 0;
      newAssetInfo[index]['cgst'] = 0;
      newAssetInfo[index]['totalgst'] = 0;
      let totalgst = newAssetInfo[index]['totalgst'];
      let cost_per_unit = newAssetInfo[index]['cost_per_unit'];
      let quantity = newAssetInfo[index]['quantity'];
      newAssetInfo[index]['totalCGST'] = (quantity * cost_per_unit * newAssetInfo[index]['cgst']) / 100;
      newAssetInfo[index]['totalSGST'] = (quantity * cost_per_unit * newAssetInfo[index]['sgst']) / 100;
      newAssetInfo[index]['totalIGST'] = (quantity * cost_per_unit * newAssetInfo[index]['igst']) / 100;
      newAssetInfo[index]['totalWithoutGST'] = quantity * cost_per_unit;
      newAssetInfo[index]['total'] = calculateTotal(quantity, cost_per_unit, totalgst);
      // set capitalised value
      if (newAssetInfo[index]['capitalisation'] === 'withoutGST') {
        newAssetInfo[index]['capitalisedValue'] = quantity * cost_per_unit;
      } else {
        newAssetInfo[index]['capitalisation'] = 'withGST';
        newAssetInfo[index]['capitalisedValue'] = calculateTotal(quantity, cost_per_unit, totalgst);
      }
    }
    if (fieldName === 'assetCategoryId') {
      let assetCatId = event.target.value;
      const [assetNumber, assetType] = calculateAssetNumber(assetCatId, index);
      newAssetInfo[index]['asset_number'] = assetNumber;
      newAssetInfo[index]['asset_type'] = assetType;
      if (assetCatId == '7') {
        newAssetInfo[index]['vehicleNumber'] = '';
        newAssetInfo[index]['chasisNumber'] = '';
        newAssetInfo[index]['engineNumber'] = '';
      }
    } else if (
      fieldName === 'quantity' ||
      fieldName === 'cost_per_unit' ||
      fieldName === 'cgst' ||
      fieldName === 'igst' ||
      fieldName === 'total'
    ) {
      let quantity = newAssetInfo[index]['quantity'];
      let cost_per_unit = newAssetInfo[index]['cost_per_unit'];
      let totalgst = newAssetInfo[index]['totalgst'];

      if (fieldName === 'quantity') {
        quantity = event.target.value;
      }
      if (fieldName === 'cost_per_unit') {
        cost_per_unit = event.target.value;
      }
      if (fieldName === 'cgst' || fieldName === 'igst') {
        newAssetInfo[index][fieldName] = event.target.value;
        const cgst = parseFloat(newAssetInfo[index]['cgst'] || 0);
        newAssetInfo[index]['sgst'] = cgst;
        const sgst = parseFloat(newAssetInfo[index]['sgst'] || 0);
        const igst = parseFloat(newAssetInfo[index]['igst'] || 0);
        totalgst = cgst + sgst + igst;
        newAssetInfo[index]['totalgst'] = totalgst;
      }
      if (fieldName === 'total') {
        newAssetInfo[index]['total'] = event.target.value === '' ? 0 : event.target.value;
      } else {
        newAssetInfo[index]['total'] = calculateTotal(quantity, cost_per_unit, totalgst || 0);
      }
      newAssetInfo[index]['totalCGST'] = (quantity * cost_per_unit * newAssetInfo[index]['cgst']) / 100;
      newAssetInfo[index]['totalSGST'] = (quantity * cost_per_unit * newAssetInfo[index]['sgst']) / 100;
      newAssetInfo[index]['totalIGST'] = (quantity * cost_per_unit * newAssetInfo[index]['igst']) / 100;
      newAssetInfo[index]['totalWithoutGST'] = quantity * cost_per_unit;
      // set capitalised value
      if (newAssetInfo[index]['capitalisation'] === 'withoutGST') {
        newAssetInfo[index]['capitalisedValue'] = quantity * cost_per_unit;
      } else {
        newAssetInfo[index]['capitalisation'] = 'withGST';
        newAssetInfo[index]['capitalisedValue'] = calculateTotal(quantity, cost_per_unit, totalgst);
      }
    } else if (fieldName === 'locationId') {
      if (event.target.value !== '') {
        let locationData = loadLocationData(event.target.value);
        newAssetInfo[index]['locationType'] = locationData?.type;
        newAssetInfo[index]['companyId'] = locationData?.companyId;

        // Only load location data when locationId changes
        const locationNumber = locationData?.number || '-';
        
        // Update the asset number with the new location number
        // Extract the parts of the asset number
        const assetNumber = newAssetInfo[index]['asset_number'];
        if (assetNumber && assetNumber.includes('/')) {
          const parts = assetNumber.split('/');
          if (parts.length >= 5) {
            // Format: CG/location/category/number/other
            newAssetInfo[index]['asset_number'] = `CG/${locationNumber}/${parts[2]}/${parts[3]}/${parts[4]}`;
          } else if (parts.length >= 3) {
            // Format: CG/location/category/number
            newAssetInfo[index]['asset_number'] = `CG/${locationNumber}/${parts[2]}/${parts[3]}`;
          } else if (parts.length >= 2) {
            // Handle case where the format might be different
            newAssetInfo[index]['asset_number'] = `CG/${locationNumber}/${parts[parts.length-1]}`;
          }
        }
      } else {
        newAssetInfo[index]['locationType'] = '';
        newAssetInfo[index]['companyId'] = '';
        
        // Reset location number to '-' when location is cleared
        const assetNumber = newAssetInfo[index]['asset_number'];
        if (assetNumber && assetNumber.includes('/')) {
          const parts = assetNumber.split('/');
          if (parts.length >= 5) {
            // Format: CG/location/category/number/other
            newAssetInfo[index]['asset_number'] = `CG/-/${parts[2]}/${parts[3]}/${parts[4]}`;
          } else if (parts.length >= 3) {
            // Format: CG/location/category/number
            newAssetInfo[index]['asset_number'] = `CG/-/${parts[2]}/${parts[3]}`;
          } else if (parts.length >= 2) {
            // Handle case where the format might be different
            newAssetInfo[index]['asset_number'] = `CG/-/${parts[parts.length-1]}`;
          }
        }
      }
    } else if (fieldName === 'gst_option') {
      newAssetInfo[index]['quantity'] = '';
      newAssetInfo[index]['totalgst'] = '';
      newAssetInfo[index]['cost_per_unit'] = '';
      newAssetInfo[index]['totalWithoutGST'] = '';
      newAssetInfo[index]['total'] = '';
      newAssetInfo[index]['gst_type'] = '';
      newAssetInfo[index]['igst'] = 0;
      newAssetInfo[index]['cgst'] = 0;
      newAssetInfo[index]['sgst'] = 0;
      newAssetInfo[index]['capitalisedValue'] = 0;
    } else if (fieldName === 'capitalisation') {
      if (event.target.value === 'withoutGST') {
        newAssetInfo[index]['capitalisedValue'] = newAssetInfo[index]?.totalWithoutGST;
      } else {
        newAssetInfo[index]['capitalisedValue'] = newAssetInfo[index]?.total;
      }
    }
    let amount = 0;
    let _totalWithoutGST = 0;
    let _totalCGST = 0;
    let _totalSGST = 0;
    let _totalIGST = 0;
    for (let i = 0; i < newAssetInfo.length; i++) {
      _totalWithoutGST += parseFloat(newAssetInfo[i]?.totalWithoutGST || 0);
      _totalCGST += parseFloat(newAssetInfo[i]?.totalCGST || 0);
      _totalSGST += parseFloat(newAssetInfo[i]?.totalSGST || 0);
      _totalIGST += parseFloat(newAssetInfo[i]?.totalIGST || 0);
      amount += parseFloat(newAssetInfo[i]?.total || 0);
    }
    setTotals({ ...totals, _totalWithoutGST, _totalSGST, _totalCGST, _totalIGST });
    setSubTotal(amount + parseInt(grnForm?.charge_amount || 0));
    newAssetInfo[index][fieldName] = event.target.value;
    setInputFields(newAssetInfo);
    setGrnForm({ ...grnForm, assetsInfo: newAssetInfo });
  };

  return (
    <React.Fragment>
      <ToastContainer />
      <Breadcrumb
        navigation={[
          { link: '#', title: 'Fixed Asset' },
          { link: '#', title: 'GRN' },
        ]}
      />
      <div className="row justify-content-between align-items-center mt-2">
        <div className="col-12 text-end mb-2">
          <button type="button" className="btn app-btn-default dark-color btn-sm" onClick={handleShow} style={{ minWidth: '80px' }}>
            Add GRN
          </button>
          <a ref={clickToDownload} href="/" target="_blank" className="hiddenItem">
            HiddenClick
          </a>
        </div>
      </div>
      <div className="card custom_card">
        <div className="d-flex justify-content-between align-items-center w-100 card-header white-color" style={{ padding: '1rem 1.7rem' }}>
          <div className="col-12 col-lg-2">
            <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
              GRN | {totalRecords ?? 0}
            </h4>
          </div>
          <div className="col-12 col-lg-2" style={{ marginRight: '12px' }}>
            <Company
              company={state.companyId}
              name="company"
              label="Company"
              onChange={(e) => {
                setState({
                  ...state,
                  companyId: e.target.value,
                  locationId: '',
                });
                setLocationType('');
              }}
            />
          </div>
          <div className="col-12 col-lg-8 text-end">
            <div className="row align-items-center">
              <div className="col-4">
                <Form.Select
                  disabled={!admins}
                  value={locationType}
                  onChange={(e) => {
                    setLocationType(e.target.value);
                    setState({ ...state, locationId: '' });
                  }}
                  className="input mb-2"
                >
                  <option value="">Select Location Type</option>
                  <option value="office">Office</option>
                  <option value="factory">Factory</option>
                  <option value="outlet">Outlet</option>
                  <option value="staff-room">Staff Room</option>
                </Form.Select>

                <FloatingLabel controlId="floatingInput" label="GRN Start Date">
                  <Form.Control value={state.dateFrom} onChange={(e) => setState({ ...state, dateFrom: e.target.value })} type="date" />
                </FloatingLabel>
              </div>
              <div className="col-3">
                <Form.Select
                  value={state.locationId}
                  onChange={(e) => setState({ ...state, locationId: e.target.value })}
                  className="input mb-2"
                >
                  <option value="">Select Location</option>
                  {locationList
                    .filter((item) => {
                      if (!admins) {
                        return (
                          storedData?.locationId.includes(item?.id) &&
                          item?.type === locationType &&
                          item?.companyId === parseInt(state?.companyId)
                        );
                      } else {
                        return item?.type === locationType && item?.companyId === parseInt(state?.companyId);
                      }
                    })
                    .map((item) => {
                      return (
                        <option key={item?.id} value={item?.id}>
                          {item?.name}
                        </option>
                      );
                    })}
                </Form.Select>

                <FloatingLabel controlId="floatingInput" label="GRN End Date">
                  <Form.Control value={state.dateTo} onChange={(e) => setState({ ...state, dateTo: e.target.value })} type="date" />
                </FloatingLabel>
              </div>
              <div className="col-4">
                <Form.Select
                  onChange={(e) => setState({ ...state, assetCategoryQuery: e.target.value })}
                  className="input mb-2"
                  value={state.assetCategoryQuery}
                >
                  <option value="">Select Asset Category</option>
                  {assetCategoryList.map((item) => {
                    return (
                      <option key={item?.id} value={item?.id}>
                        {item?.name}
                      </option>
                    );
                  })}
                </Form.Select>
                <div className="form-floating">
                  <Form.Control
                    value={state.query}
                    onChange={(e) => setState({ ...state, query: e.target.value })}
                    type="search"
                    placeholder="Search by vendor name"
                  />
                  <label htmlFor="floatingInput">Search by vendor name</label>
                </div>
              </div>
              <div className="col-1">
                <GrDocumentExcel
                  title="Download Excel"
                  className="react-icons green"
                  style={{ width: '30px', height: '30px', cursor: 'pointer' }}
                  onClick={() => getGRNs('download')}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="card-body px-0 vehicle-requests-table pt-0 pb-0">
          <div className="row">
            <div className="col">
              <Table responsive striped>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>GRN No</th>
                    <th>GRN Date</th>
                    <th>Vendor Name</th>
                    <th>Bill No</th>
                    <th>Date Of Purchase</th>
                    <th>Date Of Use</th>
                    <th>Total</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {grnList.map((item, index) => {
                    return (
                      <tr key={item?.id}>
                        <td>{(currentPage - 1) * TABLE_DEFAULT_LIMIT + (index + 1)}</td>
                        <td>{item?.grn_number}</td>
                        <td>{new Date(item?.grn_date).toLocaleDateString('en-GB')}</td>
                        <td>{item?.VendorMaster?.name}</td>
                        <td>{item?.bill_number}</td>
                        <td>{new Date(item?.date_of_purchase).toLocaleDateString('en-GB')}</td>
                        <td>{new Date(item?.date_of_put_to_use).toLocaleDateString('en-GB')}</td>
                        <td>{item?.total}</td>
                        <td className="actions pe-2">
                          <a href="/" onClick={(e) => uploadInvoice(e, item?.id)}>
                            <UploadIcon style={{ color: 'green' }} />
                          </a>
                          <a href="/" onClick={(e) => handleViewAndEdit(e, item?.id, true, 'editMode')}>
                            <EditIcon style={{ color: 'green' }} />
                          </a>
                          <a href="/" onClick={(e) => handleViewAndEdit(e, item?.id, true, 'viewMode')}>
                            <ViewIcon style={{ color: 'purple' }} />
                          </a>
                          <a href="/" onClick={(e) => handleViewAndEdit(e, item?.id, false, 'download')}>
                            <GrDocumentPdf className="react-icons red" title="download pdf" />
                          </a>
                          <a href="/" onClick={(e) => downloadQrCode(e, item)} title="Download QR Code">
                            <FaQrcode />
                          </a>
                          <div style={{ display: 'none' }}>
                            <QRCode
                              id={`temp-qr-${item.id}`}
                              value={item?.syncedOnBucket
                                ? `${process.env.REACT_APP_DIGITAL_OCEAN_URL}/${item?.invoice}`
                                : `${process.env.REACT_APP_BASE_URL}/file/download?filePath=${item?.invoice}`}
                              size={100}
                              level="H"
                              style={{ height: 'auto', maxWidth: '100%', width: '100%' }}
                            />
                          </div>
                          {item?.invoice && (
                            <a
                              href={
                                item?.syncedOnBucket
                                  ? `${process.env.REACT_APP_DIGITAL_OCEAN_URL}/${item?.invoice}`
                                  : `${process.env.REACT_APP_BASE_URL}/file/download?filePath=${item?.invoice}`
                              }
                              target="_blank"
                              rel="noreferrer"
                            >
                              <DownloadIcon style={{ color: 'purple' }} />
                            </a>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
              <PaginationInPage
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                totalRecords={totalRecords}
                TABLE_DEFAULT_LIMIT={TABLE_DEFAULT_LIMIT}
              />
            </div>
          </div>
        </div>
      </div>
      {/* GRN Add/Update */}
      <Modal size="lg" show={showConfirmModel} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header>
          <Modal.Title>
            {view === true && 'id' in grnForm ? 'GRN Details' : 'id' in grnForm ? 'Edit GRN' : isLoading ? 'Loading...' : 'Add GRN'}
          </Modal.Title>
          <button type="button" className="btn-close" aria-label="Close" onClick={handleClose}></button>
        </Modal.Header>
        <Modal.Body>
          {isLoading ? (
            <Spinner animation="border" variant="info" />
          ) : (
            <Form autoComplete="off" onSubmit={handleSubmit}>
              <h6>Basic Info</h6>
              <Row>
                <Col xs={6}>
                  <FloatingLabel controlId="floatingInput" label="GRN Date" className="mb-3">
                    <Form.Control
                      disabled={view === true}
                      className="input"
                      value={grnForm.grn_date}
                      name="grn_date"
                      onChange={handleChange}
                      type="date"
                      placeholder="GRN Date"
                      required
                    />
                  </FloatingLabel>
                </Col>
                <Col xs={6}>
                  <FloatingLabel controlId="floatingInput" label="GRN No." className="mb-3">
                    <Form.Control
                      disabled
                      className="input"
                      name="grn_number"
                      value={grnForm.grn_number}
                      onChange={handleChange}
                      type="text"
                      placeholder="GRN No."
                      required
                    />
                  </FloatingLabel>
                </Col>
              </Row>
              <Row>
                <Col xs={4}>
                  <Vendor
                    name="vendorMasterId"
                    vendorId={grnForm?.vendorMasterId}
                    handleVendorChange={(vendorId) => handleVendorChange(vendorId)}
                    isDisabled={view === true}
                  />
                </Col>
                <Col xs={4}>
                  <FloatingLabel controlId="floatingInput" label="Vendor GST" className="mb-3">
                    <Form.Control
                      disabled
                      className="input"
                      name="gst_num"
                      value={grnForm.gst_num}
                      onChange={handleChange}
                      type="text"
                      placeholder="Vendor GST"
                    />
                  </FloatingLabel>
                </Col>
                <Col xs={4}>
                  <FloatingLabel controlId="floatingInput" label="Vendor Address" className="mb-3">
                    <Form.Control
                      disabled
                      className="input"
                      name="address"
                      value={grnForm.address}
                      onChange={handleChange}
                      type="text"
                      placeholder="Vendor Address"
                    />
                  </FloatingLabel>
                </Col>
                <Col xs={4}>
                  <FloatingLabel controlId="floatingInput" label="Vendor Contact" className="mb-3">
                    <Form.Control
                      disabled
                      className="input"
                      name="contact_num"
                      value={grnForm.contact_num}
                      onChange={handleChange}
                      type="text"
                      placeholder="Vendor Contact"
                    />
                  </FloatingLabel>
                </Col>
                <Col xs={4}>
                  <FloatingLabel controlId="floatingInput" label="Vendor Email" className="mb-3">
                    <Form.Control
                      disabled
                      className="input"
                      name="email"
                      value={grnForm.email}
                      onChange={handleChange}
                      type="text"
                      placeholder="Vendor Email"
                    />
                  </FloatingLabel>
                </Col>
                <Col xs={4}>
                  <FloatingLabel controlId="floatingInput" label="Vendor City" className="mb-3">
                    <Form.Control
                      disabled
                      className="input"
                      name="city"
                      value={grnForm.city}
                      onChange={handleChange}
                      type="text"
                      placeholder="Vendor City"
                    />
                  </FloatingLabel>
                </Col>
                <Col xs={4}>
                  <FloatingLabel controlId="floatingInput" label="Pin Code" className="mb-3">
                    <Form.Control
                      disabled
                      className="input"
                      name="pincode"
                      value={grnForm.pincode}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (!isNaN(value) && value >= 0) {
                          handleChange(e);
                        }
                      }}
                      type="text"
                      placeholder="Pincode"
                    />
                  </FloatingLabel>
                </Col>
                <Col xs={4}>
                  <FloatingLabel controlId="floatingInput" label="State" className="mb-3">
                    <Form.Select className="input" disabled value={grnForm?.state} name="state" onChange={handleChange}>
                      <option value="">Select State</option>
                      {states.map((item) => {
                        return (
                          <option key={item?.value} value={item?.value}>
                            {item?.label}
                          </option>
                        );
                      })}
                    </Form.Select>
                  </FloatingLabel>
                </Col>
                <Col xs={4}>
                  <FloatingLabel controlId="floatingInput" label="Country" className="mb-3">
                    <Form.Select disabled className="input" value={grnForm?.country} name="country" onChange={handleChange}>
                      <option value="">Select Country</option>
                      <option value="IND">India</option>
                      <option value="OTH">Other</option>
                    </Form.Select>
                  </FloatingLabel>
                </Col>
              </Row>
              <Row>
                <Col xs={4}>
                  <FloatingLabel controlId="floatingInput" label="Bill Number" className="mb-3">
                    <Form.Control
                      disabled={view && !edit}
                      className="input"
                      name="bill_number"
                      value={grnForm.bill_number}
                      onChange={handleChange}
                      type="text"
                      placeholder="Bill Number"
                      required
                    />
                  </FloatingLabel>
                </Col>
                <Col xs={4}>
                  <FloatingLabel controlId="floatingInput" label="Date of Purchase" className="mb-3">
                    <Form.Control
                      disabled={view === true}
                      className="input"
                      value={grnForm.date_of_purchase}
                      name="date_of_purchase"
                      onChange={handleChange}
                      type="date"
                      placeholder="Date of Purchase"
                      required
                    />
                  </FloatingLabel>
                </Col>
                <Col xs={4}>
                  <FloatingLabel controlId="floatingInput" label="Date of Put to Use" className="mb-3">
                    <Form.Control
                      disabled={view === true}
                      className="input"
                      name="date_of_put_to_use"
                      value={grnForm.date_of_put_to_use}
                      onChange={handleChange}
                      type="date"
                      placeholder="Date of Put to Use"
                      required
                    />
                  </FloatingLabel>
                </Col>
              </Row>
              <Row className="mb-2 align-items-center">
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <h6 className="mb-0">Asset Info</h6>
                </div>
              </Row>
              {inputFields.map((inputField, index) => (
                <>
                  <div key={index} className="asset-info">
                    <Row className="align-items-center" wrap={true}>
                      <Col xs={4}>
                        <FloatingLabel controlId="floatingInput" label="Asset Name" className="mb-3">
                          <Form.Control
                            disabled={view && !edit}
                            className="input"
                            name="asset_name"
                            value={inputField.asset_name}
                            onChange={(e) => handleInputChange(index, e, 'asset_name')}
                            type="text"
                            placeholder="Asset Name"
                            required
                          />
                        </FloatingLabel>
                      </Col>
                      <Col xs={4}>
                        <FloatingLabel controlId="floatingInput" label="Asset Category" className="mb-3">
                          <Form.Select
                            disabled={view === true}
                            className="input"
                            value={inputField.assetCategoryId}
                            name="assetCategoryId"
                            onChange={(e) => handleInputChange(index, e, 'assetCategoryId')}
                            required
                          >
                            <option value="">Select Category</option>
                            {assetCategoryList.map((item) => {
                              return (
                                <option key={item?.id} value={item?.id}>
                                  {item?.name}
                                </option>
                              );
                            })}
                          </Form.Select>
                        </FloatingLabel>
                      </Col>
                      <Col xs={3}>
                        <FloatingLabel controlId="floatingInput" label="Asset Type" className="mb-3">
                          <Form.Select
                            disabled
                            className="input"
                            value={inputField.asset_type}
                            name="asset_type"
                            onChange={(e) => handleInputChange(index, e, 'asset_type')}
                          >
                            <option value="">Select Type</option>
                            <option value="tan">TAN</option>
                            <option value="int">INT</option>
                          </Form.Select>
                        </FloatingLabel>
                      </Col>
                      {view === true ? (
                        ''
                      ) : (
                        <Col xs={1} className="text-end mb-3">
                          {inputFields.length > 1 && (
                            <MdDelete
                              onClick={() => handleRemoveInput(index)}
                              className="text-danger"
                              style={{ cursor: 'pointer', fontSize: '27px' }}
                            />
                          )}
                        </Col>
                      )}
                      <Col className="d-none" xs={12}>
                        <FloatingLabel controlId="floatingInput" label="Entries Option" className="mb-3">
                          <Form.Select
                            disabled
                            className="input"
                            value={inputField.gst_option}
                            name="gst_option"
                            onChange={(e) => handleInputChange(index, e, 'gst_option')}
                            required
                          >
                            <option value="withGST">Quantity, Cost/unit, GST, Amount</option>
                            <option value="withoutGST">Quantity, Amount</option>
                          </Form.Select>
                        </FloatingLabel>
                      </Col>
                      <Row>
                        <Col xs={4}>
                          <FloatingLabel controlId="floatingInput" label="Quantity" className="mb-3">
                            <Form.Control
                              disabled={view === true}
                              className="input"
                              value={view === true ? (inputField.quantity === -1 ? 'LS' : inputField.quantity) : inputField.quantity}
                              name="quantity"
                              onChange={(e) => {
                                const value = e.target.value;
                                if (!isNaN(value) && value >= 0) {
                                  handleInputChange(index, e, 'quantity');
                                }
                              }}
                              type={inputField.gst_option !== ' ' ? 'number' : 'text'}
                              placeholder="Quantity"
                              required
                            />
                          </FloatingLabel>
                        </Col>
                        <Col xs={4}>
                          <FloatingLabel controlId="floatingInput" label="Unit" className="mb-3">
                            <Form.Select
                              disabled={view === true}
                              className="input"
                              value={inputField.unit}
                              name="unit"
                              onChange={(e) => handleInputChange(index, e, 'unit')}
                              required
                            >
                              <option value="">Select Unit</option>
                              <option value="number">Number</option>
                              <option value="set">Set</option>
                              <option value="pc">Pc</option>
                              <option value="kg">Kg</option>
                              <option value="meter">Meter</option>
                              <option value="roll">Roll</option>
                              <option value="ls">LS</option>
                            </Form.Select>
                          </FloatingLabel>
                        </Col>
                        {inputField.gst_option !== 'withoutGST' && (
                          <Col xs={4}>
                            <FloatingLabel controlId="floatingInput" label="Cost/Unit" className="mb-3">
                              <Form.Control
                                disabled={view === true}
                                className="input"
                                value={inputField.cost_per_unit}
                                name="cost_per_unit"
                                onChange={(e) => {
                                  const value = e.target.value;
                                  if (!isNaN(value) && value >= 0) {
                                    handleInputChange(index, e, 'cost_per_unit');
                                  }
                                }}
                                type="text"
                                placeholder="Cost Per Unit"
                                required
                              />
                            </FloatingLabel>
                          </Col>
                        )}
                        {inputField.gst_option !== 'withoutGST' && (
                          <>
                            <Col xs={4}>
                              <FloatingLabel controlId="floatingInput" label="GST Type" className="mb-3">
                                <Form.Select
                                  disabled={view === true}
                                  className="input"
                                  value={inputField.gst_type}
                                  name="gst_type"
                                  onChange={(e) => handleInputChange(index, e, 'gst_type')}
                                  required
                                >
                                  <option value="">Select GST</option>
                                  <option value="local">Local GST</option>
                                  <option value="interstate">Inter State GST</option>
                                </Form.Select>
                              </FloatingLabel>
                            </Col>

                            {inputField.gst_type === 'local' && (
                              <>
                                <Col xs={4}>
                                  <FloatingLabel controlId="floatingInput" label="CGST" className="mb-3">
                                    <Form.Select
                                      disabled={view === true}
                                      className="input"
                                      value={inputField.cgst}
                                      name="cgst"
                                      onChange={(e) => handleInputChange(index, e, 'cgst')}
                                      required
                                    >
                                      <option value="">Select CGST</option>
                                      <option value="0">0%</option>
                                      <option value="2.5">2.5%</option>
                                      <option value="6">6%</option>
                                      <option value="9">9%</option>
                                      <option value="14">14%</option>
                                    </Form.Select>
                                  </FloatingLabel>
                                </Col>
                                <Col xs={4}>
                                  <FloatingLabel controlId="floatingInput" label="SGST" className="mb-3">
                                    <Form.Select
                                      disabled
                                      className="input"
                                      value={inputField.sgst}
                                      name="sgst"
                                      onChange={(e) => handleInputChange(index, e, 'sgst')}
                                      required
                                    >
                                      <option value="">Select SGST</option>
                                      <option value="0">0%</option>
                                      <option value="2.5">2.5%</option>
                                      <option value="6">6%</option>
                                      <option value="9">9%</option>
                                      <option value="14">14%</option>
                                    </Form.Select>
                                  </FloatingLabel>
                                </Col>
                              </>
                            )}
                            {inputField.gst_type === 'interstate' && (
                              <Col xs={4}>
                                <FloatingLabel controlId="floatingInput" label="IGST" className="mb-3">
                                  <Form.Select
                                    disabled={view === true}
                                    className="input"
                                    value={inputField.igst}
                                    name="igst"
                                    onChange={(e) => handleInputChange(index, e, 'igst')}
                                    required
                                  >
                                    <option value="">Select IGST</option>
                                    <option value="0">0%</option>
                                    <option value="5">5%</option>
                                    <option value="12">12%</option>
                                    <option value="18">18%</option>
                                    <option value="28">28%</option>
                                  </Form.Select>
                                </FloatingLabel>
                              </Col>
                            )}
                          </>
                        )}
                        <Row>
                          {inputField?.gst_option === 'withGST' && (
                            <>
                              <Col xs={3}>
                                <FloatingLabel controlId="floatingInput" label="Total Without GST" className="mb-3">
                                  <Form.Control
                                    disabled={view === true || inputField?.gst_option === 'withGST'}
                                    className="input"
                                    name="totalWithoutGST"
                                    value={inputField?.totalWithoutGST}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      if (!isNaN(value) && value >= 0) {
                                        handleInputChange(index, e, 'totalWithoutGST');
                                      }
                                    }}
                                    type="text"
                                    placeholder="Total Without GST"
                                  />
                                </FloatingLabel>
                              </Col>
                              {inputField.gst_type === 'local' && (
                                <>
                                  <Col xs={3}>
                                    <FloatingLabel controlId="floatingInput" label="Total CGST" className="mb-3">
                                      <Form.Control
                                        disabled={view === true || inputField?.gst_option === 'withGST'}
                                        className="input"
                                        name="totalCGST"
                                        value={inputField?.totalCGST}
                                        onChange={(e) => {
                                          const value = e.target.value;
                                          if (!isNaN(value) && value >= 0) {
                                            handleInputChange(index, e, 'totalCGST');
                                          }
                                        }}
                                        type="text"
                                        placeholder="Total CGST"
                                      />
                                    </FloatingLabel>
                                  </Col>
                                  <Col xs={3}>
                                    <FloatingLabel controlId="floatingInput" label="Total SGST" className="mb-3">
                                      <Form.Control
                                        disabled={view === true || inputField?.gst_option === 'withGST'}
                                        className="input"
                                        name="totalSGST"
                                        value={inputField?.totalSGST}
                                        onChange={(e) => {
                                          const value = e.target.value;
                                          if (!isNaN(value) && value >= 0) {
                                            handleInputChange(index, e, 'totalSGST');
                                          }
                                        }}
                                        type="text"
                                        placeholder="Total SGST"
                                      />
                                    </FloatingLabel>
                                  </Col>
                                </>
                              )}
                              {inputField.gst_type === 'interstate' && (
                                <Col xs={3}>
                                  <FloatingLabel controlId="floatingInput" label="Total IGST" className="mb-3">
                                    <Form.Control
                                      disabled={view === true || inputField?.gst_option === 'withGST'}
                                      className="input"
                                      name="totalIGST"
                                      value={inputField?.totalIGST}
                                      onChange={(e) => {
                                        const value = e.target.value;
                                        if (!isNaN(value) && value >= 0) {
                                          handleInputChange(index, e, 'totalIGST');
                                        }
                                      }}
                                      type="text"
                                      placeholder="Total IGST"
                                    />
                                  </FloatingLabel>
                                </Col>
                              )}
                            </>
                          )}
                          <Col xs={3}>
                            <FloatingLabel controlId="floatingInput" label="Total" className="mb-3">
                              <Form.Control
                                disabled={view === true || inputField?.gst_option === 'withGST'}
                                className="input"
                                name="total"
                                value={inputField?.total}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  if (!isNaN(value) && value >= 0) {
                                    handleInputChange(index, e, 'total');
                                  }
                                }}
                                type="text"
                                placeholder="Total"
                              />
                            </FloatingLabel>
                          </Col>
                        </Row>
                      </Row>
                      <Col xs={4}>
                        <FloatingLabel controlId="floatingInput" label="Location" className="mb-3">
                          <Form.Select
                            disabled={view === true}
                            className="input"
                            value={inputField.locationId}
                            name="locationId"
                            onChange={(e) => handleInputChange(index, e, 'locationId')}
                            required
                          >
                            <option value="">Select Location</option>
                            {locationList
                              .filter((item) => {
                                if (!admins) {
                                  return storedData?.locationId.includes(item?.id);
                                } else {
                                  return item;
                                }
                              })
                              .map((item) => {
                                return (
                                  <option key={item?.id} value={item?.id}>
                                    {item?.name}
                                  </option>
                                );
                              })}
                          </Form.Select>
                        </FloatingLabel>
                      </Col>
                      <Col xs={4}>
                        <FloatingLabel controlId="floatingInput" label="Location Type" className="mb-3">
                          <Form.Select
                            className="input"
                            disabled
                            value={inputField.locationType}
                            name="locationType"
                            onChange={(e) => handleInputChange(index, e, 'locationType')}
                            placeholder="Location Type"
                            required
                          >
                            <option value="">Location Type</option>
                            <option value="office">Office</option>
                            <option value="factory">Factory</option>
                            <option value="outlet">Outlet</option>
                            <option value="staff-room">Staff Room</option>
                          </Form.Select>
                        </FloatingLabel>
                      </Col>
                      <Col xs={4}>
                        <FloatingLabel controlId="floatingInput" label="Company" className="mb-3">
                          <Company
                            disabled
                            required
                            company={inputField.companyId}
                            name="companyId"
                            label="Company"
                            onChange={(e) => handleInputChange(index, e, 'companyId')}
                          />
                        </FloatingLabel>
                      </Col>
                      <Col xs={3}>
                        <FloatingLabel controlId="floatingInput" label="Asset Number" className="mb-3">
                          <Form.Control
                            disabled
                            className="input"
                            name="asset_number"
                            value={inputField.asset_number}
                            onChange={(e) => handleInputChange(index, e, 'asset_number')}
                            type="text"
                            placeholder="Asset Number"
                          />
                        </FloatingLabel>
                      </Col>
                      <Col xs={3}>
                        <FloatingLabel controlId="floatingInput" label="Capitalisation" className="mb-3">
                          <Form.Select
                            disabled={view === true}
                            className="input"
                            value={inputField.capitalisation}
                            name="capitalisation"
                            onChange={(e) => handleInputChange(index, e, 'capitalisation')}
                            required
                          >
                            <option value="withGST">With GST</option>
                            <option value="withoutGST">Without GST</option>
                          </Form.Select>
                        </FloatingLabel>
                      </Col>
                      <Col xs={3}>
                        <FloatingLabel controlId="floatingInput" label="Capitalised Value" className="mb-3">
                          <Form.Control
                            disabled
                            className="input"
                            name="capitalisedValue"
                            value={inputField?.capitalisedValue}
                            type="number"
                            placeholder="Capitalised Value"
                          />
                        </FloatingLabel>
                      </Col>
                      {inputField.assetCategoryId == '7' && (
                        <>
                          <Col xs={3}>
                            <FloatingLabel controlId="floatingInput" label="Vehicle Number" className="mb-3">
                              <Form.Control
                                disabled={view && !edit}
                                className="input"
                                name="vehicleNumber"
                                value={inputField.vehicleNumber}
                                onChange={(e) => handleInputChange(index, e, 'vehicleNumber')}
                                type="text"
                                placeholder="Vehicle Number"
                              />
                            </FloatingLabel>
                          </Col>
                          <Col xs={3}>
                            <FloatingLabel controlId="floatingInput" label="Chasis Number" className="mb-3">
                              <Form.Control
                                disabled={view && !edit}
                                className="input"
                                name="chasisNumber"
                                value={inputField.chasisNumber}
                                onChange={(e) => handleInputChange(index, e, 'chasisNumber')}
                                type="text"
                                placeholder="Chasis Number"
                              />
                            </FloatingLabel>
                          </Col>
                          <Col xs={3}>
                            <FloatingLabel controlId="floatingInput" label="Engine Number" className="mb-3">
                              <Form.Control
                                disabled={view && !edit}
                                className="input"
                                name="engineNumber"
                                value={inputField.engineNumber}
                                onChange={(e) => handleInputChange(index, e, 'engineNumber')}
                                type="text"
                                placeholder="Engine Number"
                              />
                            </FloatingLabel>
                          </Col>
                        </>
                      )}
                    </Row>
                  </div>
                  <hr />
                </>
              ))}
              <Row className="mb-2">
                <Col xs={4}>
                  {view === true ? (
                    ''
                  ) : (
                    <Button type="button" ref={clickAssetBtn} variant="secondary" size="sm" onClick={handleAddInput}>
                      Add Asset Info
                    </Button>
                  )}
                </Col>
              </Row>
              <hr />
              <Row style={{ display: 'flex' }}>
                <Col xs={4}>
                  <Form.Select
                    disabled={view === true}
                    className="input"
                    name="charge_type"
                    value={grnForm.charge_type}
                    onChange={handleChange}
                  >
                    <option value="">Select Charge Type</option>
                    <option value="transport">Transport Charges</option>
                    <option value="other">Other</option>
                  </Form.Select>
                </Col>
                <Col xs={4}>
                  <Form.Control
                    disabled={view === true || grnForm.charge_type === ''}
                    className="input"
                    name="charge_amount"
                    value={grnForm.charge_amount}
                    onChange={handleChange}
                    type="number"
                    placeholder="Charge Amount"
                  />
                </Col>
                <Col xs={4} className="text-end px-3">
                  <h6>Total Without GST: {totals?._totalWithoutGST?.toFixed(2)}</h6>
                  <h6>CGST: {totals?._totalCGST?.toFixed(2)}</h6>
                  <h6>SGST: {totals?._totalSGST?.toFixed(2)}</h6>
                  <h6>IGST: {totals?._totalIGST?.toFixed(2)}</h6>
                  <h6>Charges: {grnForm.charge_amount}</h6>
                  <hr />
                  <h6 className="text-danger">Total: {subTotal?.toFixed(2)}</h6>
                </Col>
              </Row>
              <Row>
                {view === true && !edit ? (
                  ''
                ) : (
                  <Col>
                    <Button
                      type="submit"
                      ref={clickSubmitBtn}
                      disabled={grnBtnDisable}
                      className="add-request-btn mt-4 mb-3 justify-content-center"
                    >
                      {edit ? 'Update' : 'Submit'}
                    </Button>
                  </Col>
                )}
              </Row>
            </Form>
          )}
        </Modal.Body>
      </Modal>
      <Modal size="sm" show={uploadModel} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header>
          <Modal.Title>Upload Invoice</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Control onChange={handleFileChange} name="invoice" type="file" />
        </Modal.Body>
        <Modal.Footer>
          <div className="btn-wrapper">
            <button
              onClick={() => {
                setIdToUpdated('');
                setUploadModel(false);
              }}
              className="btn app-btn-default btn-sm"
            >
              Cancel
            </button>
            <button onClick={(e) => handleUpload(e, idToUpdated)} className="btn app-btn-primary btn-sm">
              Upload
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

export default GRN;
